/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  LockWithdrawalFeeOptions,
  LockWithdrawalFeeResponses,
} from '../types/LockWithdrawalFee'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @description Redeems a fee quote from GET /v1/web3/withdrawals/fee-quote against an admin-approved withdrawal, holding the quoted fee from the caller's available balance and making the withdrawal eligible for on-chain submission. Restricted to users whose native asset is USDC.
 * @summary Lock the network fee for an approved USDC withdrawal
 * {@link /v1/web3/withdrawals/:withdrawal_id}
 */
export function lockWithdrawalFee<ThrowOnError extends boolean = true>(
  options: Options<LockWithdrawalFeeOptions, ThrowOnError>,
): Unwrappable<RequestResult<LockWithdrawalFeeResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'PUT',
      url: '/v1/web3/withdrawals/{withdrawal_id}',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<LockWithdrawalFeeResponses, ThrowOnError>>,
  )
}
